<template>
  <IziGrid>
    <IziCol>
      <IziInput
        v-model:value="formGroup.numberQuestion.value"
        :type="'number'"
        :label="'Number Question'"
        :name="'numberQuestion'"
        :msg="msg.numberQuestion"
        @blur="blur('numberQuestion')"
      />
    </IziCol>
  </IziGrid>
</template>

<script lang="ts">
import { Options } from "vue-class-component";
import { FormGroup } from "../../../model/FormGroup.model";
import BaseForm from "../../baseForm/baseForm.vue";
@Options({})
export default class NumberQuestion extends BaseForm {
  public numberQuestion = 10;
  public formGroup: FormGroup = {
    numberQuestion: {
      rules: [],
      value: this.numberQuestion
    }
  };
}
</script>
<style lang="scss" scoped></style>
